import { IUser } from "../../../core/types/base/IUser";
import { UserPermissions } from "../../../core/types/enums/PermissionsEnum";

export const GlobalAdminRole = "Global Administrator";
const isGlobalAdmin = (user?: IUser | null): boolean =>
  !!(
    user &&
    (user.roles?.includes(GlobalAdminRole) ||
      user.rolePermissions?.includes(UserPermissions.GlobalAdmin))
  );

export { isGlobalAdmin };
